"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchReloadCache = exports.validateFunction = exports.validateParam = exports.timezoneCDNPath = exports.countryTimezoneCDNPath = exports.cityMapCDNPath = exports.apolloCDNPath = exports.getApolloConfigFromLocal = void 0;
// 获取本地配置作为最后一层兜底
var getApolloConfigFromLocal = function (flag) {
    try {
        console.warn('Elvish Info: 使用本地配置兜底中');
        // const configLocal = require('@didi/elvish-lib-javascript/config');
        var configLocal = require('../../config');
        if (flag) {
            return configLocal === null || configLocal === void 0 ? void 0 : configLocal[flag];
        }
    }
    catch (e) {
        throw Error("Elvish Fetch Error: ".concat(e.message || "\u672C\u5730".concat(flag, "\u914D\u7F6E\u83B7\u53D6\u5931\u8D25")));
    }
};
exports.getApolloConfigFromLocal = getApolloConfigFromLocal;
// apollo文件的cdn地址
exports.apolloCDNPath = 'https://static.didiglobal.com/ibt/elvish/apollo.json';
// cityMap文件的cdn地址
exports.cityMapCDNPath = 'https://static.didiglobal.com/ibt/elvish/cityMap.json';
// countryTimezone文件的cdn地址
exports.countryTimezoneCDNPath = 'https://static.didiglobal.com/ibt/elvish/countryTimezone.json';
// timezone文件的cdn地址
exports.timezoneCDNPath = 'https://static.didiglobal.com/ibt/elvish/timezone.json';
var validateParam = function (param, errorMsg) {
    if (!param) {
        throw Error("Elvish Error: invalid ".concat(errorMsg, " parameters"));
    }
};
exports.validateParam = validateParam;
var validateFunction = function (param, invalidTarget, callTarget) {
    if (!param) {
        var errorMsg = invalidTarget || param;
        throw Error("Elvish Error: please call ".concat(callTarget || 'init function', " with ").concat(errorMsg, " parameter first"));
    }
};
exports.validateFunction = validateFunction;
var fetchReloadCache = function (url) {
    return fetch(url, {
        // reload 表示本次请求忽略浏览器已经有的缓存（相当于 Ctrl + R 强制刷新），
        // 但本次请求的结果还是会遵循响应的 Cache-Control 标头的值来进行缓存存储
        cache: 'reload'
    });
};
exports.fetchReloadCache = fetchReloadCache;
